import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '../../components/templates/Layout'
import CustomTable from '../../components/molecules/CustomTable'
import CustomSearch from '../../components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import AlertContext from '../../context/alert/alertContext'
import CommunicationContext from '../../context/communication/communicationContext'
import { useLocation } from 'react-router-dom'
import TemplateManage from './TemplateManage'
import Template from './Templates'
import { useTranslation } from 'react-i18next'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
const AllTemplate = (props) => {
    const alertContext = useContext(AlertContext)
    const communicationContext = useContext(CommunicationContext)
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(true)
    const search = useLocation().search
    const { t } = useTranslation()
    const dynamicContext = useContext(DynamicContext)
    const edit = new URLSearchParams(search).get('edit')
    console.log('edit', edit)
    const { setAlert } = alertContext
    const {
        all_templates,
        getAllSearchTemplates,
        responseStatus: responseStatusCommuncation,
        clearResponse: clearResponseCommuncation,
    } = communicationContext
    const { propertyColumnReOrder } = dynamicContext
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    let action = props.action ? props.action : props.match?.params?.action

    const toggleFullScreenPopup = (popup, status, id, secondaryID) => {
        if (popup) {
            setManage({ popup, status, id, secondaryID })
        } else {
            setManage({ popup, status: 'new', id: 0, secondaryID: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formik = useFormik({
        initialValues: {
            action: action,
            searchterm: '',
            page: 1,
            limit: 20,
            order: 'asc',
            orderby: global.enableReorderTemplate ? 'show_order' : 'id',
        },
        onSubmit: (values) => {
            setIsLoading(true)
            getAllSearchTemplates(values)
        },
    })

    useEffect(() => {
        if (all_templates) {
            setTableBody(
                all_templates.records.length ? all_templates.records : []
            )
        }
        setIsLoading(false)
    }, [all_templates])

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        formik.values.action = action
        formik.values.page = 1
        formik.values.searchterm = ''
        getAllSearchTemplates(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action])

    useEffect(() => {
        if (responseStatusCommuncation) {
            if (
                responseStatusCommuncation.from === 'Communicationtemplates' &&
                responseStatusCommuncation.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                setTableBody([])
                formik.values.action = action
                formik.values.page = 1
                formik.values.searchterm = ''
                getAllSearchTemplates(formik.values)
            }
        }
    }, [responseStatusCommuncation])

    const onClickEdit = (id, secondaryID, type) => {
        console.log('type,id', type, id, secondaryID)
        if (type === 'edit') {
            toggleFullScreenPopup(true, 'edit', id)
        } else if (type === 'view') {
            toggleFullScreenPopup(true, 'view', id)
        } else {
            toggleFullScreenPopup(true, 'new', id)
        }
    }
    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        })
        if (edit) {
            actionPush.push({
                buttonType: 'library_add_check',
                clickType: 'view',
                onclick: onClickEdit,
                tooltipTitle: 'Template Phrases',
            })
        }
        return actionPush
    }

    const resetForm = () => {
        formik.values.searchterm = ''
        getAllSearchTemplates(formik.values)
    }

    const tableValues = [
        {
            field: 'title',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: t('Subject'),
            // width: 500,
            // flex: 1,
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: t('Action'),
            isMultiple: getMultipleAction(),
            // flex: 1,
        },
    ]

    const searchInfo = [
        {
            label: t('Subject'),
            placeholder: 'Enter Subject',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formik,
        },
    ]

    return (
        <>
            {props.layout ? (
                <>
                    <div className="dashboard communications">
                        <CustomSearch searchInfo={searchInfo} formik={formik} />
                        <CustomTable
                            formik={formik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={all_templates}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getAllSearchTemplates}
                            hideCompactView={props.hideCompactView}
                        />
                    </div>
                    <TemplateManage
                        action={action}
                        data={manage}
                        function={toggleFullScreenPopup}
                    />
                    <Template data={manage} function={toggleFullScreenPopup} />
                </>
            ) : (
                <Layout
                    noUI={props.noUI || false}
                    renderSidePanelDefault={
                        props.renderSidePanelDefault || false
                    }
                >
                    {' '}
                    <div className="dashboard communications">
                        <CustomSearch searchInfo={searchInfo} formik={formik} />
                        <div className="miscActions d-flex justify-content-between align-items-center mt-4">
                            <Button
                                id="template_new"
                                variant="outlined"
                                className="btnOutlined"
                                onClick={() =>
                                    toggleFullScreenPopup(true, 'new', 0)
                                }
                            >
                                {isLoading && <div>Loading..</div>}
                                <span className="material-icons">
                                    person_add_alt_1
                                </span>
                                {t('Add New Template')}
                            </Button>
                        </div>
                        <CustomTable
                            reorder={
                                global.enableReorderTemplate ? true : false
                            }
                            formik={formik.values}
                            tableBody={tableBody}
                            propertyColumnReOrder={propertyColumnReOrder}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={all_templates}
                            isLoading={isLoading}
                            reorderTable="templates"
                            loadingTemplate={'table'}
                            changeTableFunction={getAllSearchTemplates}
                            hideCompactView={props.hideCompactView}
                        />
                    </div>
                    <TemplateManage
                        action={action}
                        data={manage}
                        function={toggleFullScreenPopup}
                    />
                    <Template data={manage} function={toggleFullScreenPopup} />
                </Layout>
            )}
        </>
    )
}
export default AllTemplate
